export const canUseDom = !!(typeof window !== 'undefined' && window.document) as boolean;
